module.exports = __webpack_public_path__ + "img/lock.b90d70aa.svg";